import React, { useContext, useState, useEffect } from "react";
import "./Appointments.scss";
import CustomModal from "../UI Component/Modal/ModalCustom";
import { filterRecords, filters, getDateByRanges } from "./constants";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import { DateRangePicker } from "react-date-range";
import moment from "moment";
import useWindowSize from "../../Hooks/useWindowSize";
import useDisableHelp from "../../Hooks/useDisableHelp";
import searchIcon from "../../assets/forhomepage/search_icon.svg";
import closeIcon from "../../assets/forhomepage/close_icon.svg";
import afterLoginApiAxios from "../../Util/API Calls/afterLogin";
import DoctorContext from "../ClinicComponents/ClinicWrapper/DoctorContext";
import { LOCALSTORAGEKEY } from "../../Util/Helper/localStorageUtils";
import { C2CConsole } from "../../Util/Helper/C2CConsole";

export default function FilterModal(props) {
  const {
    show,
    handleClose,
    date,
    appointmentStatus,
    status,
    prescriptionStatus,
    start,
    end,
    onFilterSuccess,
    onResetAllCall,
    selectedAppointmentType,
    mobileFilterData,
    temp_doctor_selected,
    doctor_selected,
    onlyDoctorName,
  } = props;
  let is_staff = localStorage.getItem("user_type");
  const userId = localStorage.getItem(LOCALSTORAGEKEY.USER_ID);
  const clinicId = localStorage.getItem(LOCALSTORAGEKEY.CLINIC_ID);

  const staff_context = useContext(DoctorContext);
  const [sideMenu, setSideMenu] = useState("date");
  const [inputText, setInputText] = useState("");
  const [allConsultationType, setAllConsultationType] = useState([]);

  useEffect(() => {
    if (is_staff === "staff") {
      let list = [
        { name: "All", value: "all", doctor_id: doctor_selected },
        ...staff_context?.selectedDoctor,
      ];
      let temp;
      temp = filters;
      temp.doctorName = list;
    } else {
      // delete filters["sideMenu"] = doctorName;
    }
  }, [staff_context.selectedDoctor]);

  const size = useWindowSize();
  useDisableHelp();

  const [selectionRange, setSelectionRange] = useState({
    startDate: null,
    endDate: null,
    dateDisplayFormat: "DD MMM YYYY",
    rangeColors: "#F969A4",
    color: "#F969A4",
    key: "selection",
  });
  const [filterData, setFilterData] = useState({
    doctorName: "",
    prescriptionStatus: "",
    status: "",
    appointmentStatus: "",
    date: "Today",
  });
  const [filteritemData, setFilteritemData] = useState({
    doctorName: "",
    prescriptionStatus: "",
    status: "",
    appointmentStatus: "",
    date: "Today",
  });
  const [allFilters, setAllFilters] = useState();
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [resetValues, setResetValues] = useState(false);

  useEffect(() => {
    setFilterData({
      // // doctorsRelatedDataStatus: doctorsRelatedDataStatus,
      doctorName: temp_doctor_selected,
      appointmentStatus: appointmentStatus,
      status: status,
      prescriptionStatus: prescriptionStatus,
      date: date || "Today",
    });
    setFilteritemData({
      doctorName: onlyDoctorName,
      appointmentStatus: appointmentStatus,
      status: status,
      prescriptionStatus: prescriptionStatus,
      date: date || "Today",
    });
    setAllFilters(mobileFilterData);
    setSelectionRange({
      ...selectionRange,
      startDate: start != "" ? new Date(start) : null,
      endDate: end != "" ? new Date(end) : null,
    });
  }, []);

  useEffect(() => {
    getConsultatiionFilterList();
  }, [doctor_selected]);

  const getConsultatiionFilterList = () => {
    afterLoginApiAxios({
      method: "post",
      url: "/doctor/get-all-procedures",
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("id_token"),
      },
      data: {
        doctor_ids: doctor_selected.length > 0 ? doctor_selected : [userId],
        clinic_id: clinicId ?? "",
      },
    })
      .then((res) => {
        if (res?.data && res?.data?.procedures?.length > 0) {
          let modifiedResponse = [];
          res.data.procedures.map((data, index) => {
            let obj = {};
            obj["name"] = data;
            obj["value"] = data;
            obj["type"] = "procedure";
            modifiedResponse.push(obj);
          });
          let temp;
          temp = filters;
          temp.status = [...temp.status, ...modifiedResponse];
          setAllConsultationType(temp.status);
        }
      })
      .catch((err) => {
        C2CConsole.log(err);
      });
  };

  const onHandleMethodCall = (item) => {
    const sideBar = filters.sideMenu.find((filter) => filter.value == sideMenu);

    if (sideMenu === "date") {
      const range = getDateByRanges(item.value);
      setSelectionRange({
        ...selectionRange,
        startDate: new Date(range.startDate),
        endDate: new Date(range.endDate),
      });
    }
    if (sideMenu !== "date") {
      setAllFilters({ ...allFilters, [sideBar.value]: item });
    }
    if (sideMenu === "doctorName") {
      setFilterData({
        ...filterData,
        [sideBar.value]: item,
      });
    }
    if (sideMenu === "status") {
      setFilterData({
        ...filterData,
        [sideBar.value]: item,
      });
    } else {
      setFilterData({
        ...filterData,
        [sideBar.value]: item.value,
      });
    }

    setFilteritemData({ ...filteritemData, [sideBar.value]: item.value });
  };

  const getFilterValues = (label) => {
    setSelectedStatus(label);
  };
  const onCloseCall = (filterData) => {
    onFilterSuccess({
      doctor_id: Array.isArray(filterData.doctorName.doctor_id)
        ? filterData.doctorName.doctor_id
        : [filterData.doctorName.doctor_id],
      status: filterData.status,
      appointmentStatus: filterData.appointmentStatus,
      prescriptionStatus: filterData.prescriptionStatus,
      startDate: selectionRange.startDate,
      endDate: selectionRange.endDate,
      doctorName: filterData.doctorName.value,
      allFilters,
      resetValues,
    });
    setFilteritemData({
      // doctorsRelatedDataStatus: filterData.doctorName.value,
      doctorName: filterData.doctorName.value,
      appointmentStatus: filterData.appointmentStatus,
      status: filterData.status,
      prescriptionStatus: filterData.prescriptionStatus,
      date: filterData.date,
    });
  };

  const handleSelect = (ranges) => {
    setSelectionRange(ranges);
  };

  const DateTimeRangeRender = () => {
    return (
      <DateRangePicker
        ranges={[selectionRange]}
        startDatePlaceholder="From"
        endDatePlaceholder="To"
        showSelectionPreview={true}
        editableDateInputs={true}
        showPreview={false}
        staticRanges={[]}
        inputRanges={[]}
        dragSelectionEnabled={true}
        onChange={(item) => handleSelect(item.selection)}
        className="range-only-date m-auto"
        maxDate={moment().add(1, "years").toDate()}
      />
    );
  };

  // function to filter the consultation type based on the search string.
  const onSubmit = (event) => {
    setInputText(event["search_string"]);
    let temp;
    temp = filters;
    let searchedName = allConsultationType.filter((data) =>
      data.name
        .toLocaleLowerCase()
        .includes(event["search_string"].toLocaleLowerCase())
    );
    temp.status = searchedName;
  };

  // function to clear consultation type searched string.
  const clearData = () => {
    setInputText("");
    let temp;
    temp = filters;
    temp.status = allConsultationType;
  };

  return (
    <CustomModal show={show && size.width < 1024 ? show : false}>
      <div className="d-flex col-sm-12 d-lg-none appointment-filter-header-div">
        <div className="appointment-filter-header-tittle-div">Filters</div>
        <div className="ml-auto" onClick={() => handleClose()}>
          Close
          <i className="fa fa-close pl-1" aria-hidden="true"></i>
        </div>
      </div>

      <div
        className={`appointment-filter-body-div d-flex ${
          sideMenu === "date" && filterData["date"] === "Date Range"
            ? "appointment-filter-body-cal-div"
            : ""
        }`}
      >
        <div className={`appointment-filter-body-sidebar-div col-sm-6 p-0`}>
          {filters.sideMenu.map((item, i) => {
            if (
              (selectedAppointmentType &&
                selectedAppointmentType.value === "upcoming" &&
                item.value === "prescriptionStatus") ||
              (localStorage.getItem("user_type") == "doctor" &&
                item.name == "Doctor Name")
            ) {
              return null;
            } else
              return (
                <div
                  className={`${sideMenu === item.value ? "active" : ""}`}
                  key={i}
                  onClick={() => {
                    setSideMenu(item.value);
                    getFilterValues(item.value);
                  }}
                >
                  {item.name}
                </div>
              );
          })}
        </div>

        <div className="col-sm-6">
          {selectedStatus == "status" && (
            <div className="search-wrapper">
              <div className="input-holder">
                <input
                  type="text"
                  className="search-input"
                  onChange={(e) => onSubmit({ search_string: e.target.value })}
                  value={inputText}
                  placeholder="Search for Procedure."
                />{" "}
                <div className="search-icon">
                  <img src={searchIcon} />
                </div>
                {inputText !== "" && (
                  <div className="close_serch">
                    <img src={closeIcon} onClick={clearData} />
                  </div>
                )}
              </div>
            </div>
          )}
          {filters[sideMenu].map((item, i) => {
            let status;
            if (
              selectedStatus === "appointmentStatus" &&
              selectedAppointmentType &&
              (selectedAppointmentType.value === "upcoming" ||
                selectedAppointmentType.value === "past")
            ) {
              status = filterRecords(selectedAppointmentType.value, item.value);
              if (filterRecords(selectedAppointmentType.value, item.value)) {
                return (
                  <div
                    className="appointment-filter-body-right-div"
                    key={i}
                    onClick={() => onHandleMethodCall(item)}
                  >
                    <i
                      className={`fa fa-check mr-1 check-icon-filter ${
                        filteritemData[sideMenu] === item.value
                          ? "activeTab"
                          : ""
                      }`}
                      aria-hidden="true"
                    ></i>
                    {item.name}
                  </div>
                );
              }
            } else {
              return (
                <div
                  className="appointment-filter-body-right-div"
                  key={i}
                  onClick={() => onHandleMethodCall(item)}
                >
                  <i
                    className={`fa fa-check mr-1 check-icon-filter ${
                      filteritemData[sideMenu] === item.value ? "activeTab" : ""
                    }`}
                    aria-hidden="true"
                  ></i>
                  {item.name}
                </div>
              );
            }
          })}
        </div>
      </div>

      {sideMenu === "date" && filterData["date"] === "Date Range" ? (
        <div className="d-flex m-auto">{DateTimeRangeRender()}</div>
      ) : (
        ""
      )}

      <div className="d-flex col-sm-12 appointment-date-range-buttons-div p-2">
        <a
          className="ml-auto appointment-date-range-reset"
          onClick={() => {
            onResetAllCall();
            setResetValues(true);
          }}
        >
          Reset All
        </a>
        <button
          className="ml-2 btn-primary appointment-date-range-apply"
          onClick={() => onCloseCall(filterData)}
        >
          Apply
        </button>
      </div>
    </CustomModal>
  );
}
